export default __webpack_public_path__ + "static/media/ThaiSansNeue-Bold.9b8b4cc9.ttf";